import React, { useRef, useState } from 'react'
import { flushSync } from 'react-dom'
import { selectText, useCopy } from '../clipboard/clipboard'
import { IconCheck, IconCopy, IconHide, IconView } from '../icon/icon'
import '../../layout/authorized/org/api-keys/api-keys.scss'

// A secret that is shown once (an API key, a SCIM token, a publish key, a
// webhook signing secret), masked until the person asks (owner 2026-10-26).
//
// Masked, the page holds a fixed-length run of bullets: not the secret, and
// not its length, so a screenshot or a shoulder-surfer gets nothing. Show
// switches to the real text and becomes Hide. Copy copies the real value
// from props either way (nothing is kept in the DOM to copy from). When the
// browser refuses the copy, the secret is revealed first and then selected,
// so the person can press the shortcut on what they can see.
//
// The mask, Show and Copy read as one joined control (owner 2026-10-29), Copy
// the primary end of it; on a phone the buttons go under the value. Show and
// Hide carry the eye and the eye-slash beside their words (owner 2026-10-29,
// asked for before): the eye while the secret is masked, the slash once shown.
export const MASK = '••••••••••••••••••••••••'

// plain: a value that is not secret (the Tenant URL), shown in full with
// only Copy, in the same wrapped field.
export const SecretField = ({ value, noun = 'secret', plain = false, testId, className = 'ak-secret', valueClassName = 'ak-secret-value sw-mono', copyRef }) => {
  const [shownState, setShown] = useState(false)
  const shown = plain || shownState
  const textRef = useRef(null)
  const copy = useCopy()

  const onCopy = () => {
    // Starts the copy inside the click (the clipboard helper's rule).
    const started = copy.copy(value, null)
    started.then(copied => {
      if (copied) return
      flushSync(() => setShown(true))
      selectText(textRef)
    })
  }

  return (
    <>
      <div className={className}>
        <code className={valueClassName} data-testid={testId} data-masked={shown ? 'false' : 'true'} ref={textRef}>{shown ? value : MASK}</code>
        {!plain && <button type="button" className="btn sw-btn btn-sm" aria-pressed={shown} aria-label={`${shown ? 'Hide' : 'Show'} the ${noun}`} onClick={() => setShown(s => !s)}>
          {shown ? <IconHide /> : <IconView />} {shown ? 'Hide' : 'Show'}
        </button>}
        <button type="button" ref={copyRef} className={`btn sw-btn-primary btn-sm ${copy.copied ? 'is-copied' : ''}`} aria-label={`Copy the ${noun}`} onClick={onCopy}>
          {copy.copied ? <IconCheck /> : <IconCopy />} {copy.copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      {copy.manual && <p className="sw-hint small mt-1" role="status">{copy.hint}</p>}
    </>
  )
}
